export default __webpack_public_path__ + "static/Freight-SansBook-9b8192b25172aa319566895405f4379b.woff2";